import getS3Data from '@/services/s3DataService';

export default async ({ key }) => {
    try {
        // Fetch articles from S3 using getS3Data and the provided key
        const response = await getS3Data({
            Bucket: process.env.S3_COMMON_BUCKET_NAME || 'use1-awscshome-autotrader-master-content',
            Key: key,
        });
        if (response && response.errMsg === 'success' && response.s3Data) {
            return response.s3Data;
        }
    } catch (ex) {
        console.log('Error fetching article data ', JSON.stringify(ex));
    }
    return [];
};
